import {FC} from 'react'

interface Props {
    title: string,
    content: string
    contact?: boolean
}

const Message: FC<Props> = ({ title, content, contact=false}) => {
    return (
        <>
            <h2>{title}</h2>
            <p>{content}<br/>
            {contact && (
                <>
                    Vänligen kontakta oss på <a className={"text-link"} href={"tel:0105168000"}>010-516 80 00</a> eller <a className={"text-link"} href={"mailto:info@mechanum.com"}>info@mechanum.com</a><br/>så hjälper vi dig!
                </>
            )}
            </p>
        </>
    )
};



export default Message
